export default "__VITE_ASSET__036b1c52__$_?component__"